import Atom from "../../atom";
import { uploadType } from "../@types/upload";
import React, { useEffect, useState } from "react";
import Services from "../../../lib/services/services";

export default function Upload(props: uploadType) {
  const { id, getValue, onUpload, trigger, selfTrigger, getFile, ...other } = props;

  const [file, setFile] = useState<File[]>();

  useEffect(() => {
    if (trigger) {
      handleUpload();
    }
    
  }, [trigger]);

  useEffect(() => {
    if (file && selfTrigger) {
      handleUpload();
    }
    
  }, [file]);

  useEffect(()=>{
    if(!trigger && selfTrigger) {

    }
  
  });

  function getSelectedFile(value: File[]) {
    setFile(value);
    //این تابع برای این بود که بفهمیم اصلا فایلی برای آپلود وجود دارد یا نه
    getFile?.(value);
  }

  async function handleUpload() {
    const fd = new FormData();
    if (file) {
      const uploadError = document.getElementById(`${id}-error-upload`);
      fd.append(`files[0]`, file[0], file[0].name);
      if (!onUpload) {
        const result = await Services.upload({ data: fd, path: "/file" });
        // @ts-ignore
        if (!result.error) {
          //نمایش علامت آپلود موفق روی عکس
          const uploadSuccess = document.getElementById(`${id}-success-upload`);
          uploadSuccess && uploadSuccess.click();
          if (result && result.paths && !result.error) {
            const values = Object.values(result.paths);
            getValue?.(values);
          } else {
            //نمایش علامت آپلود ناموفق روی عکس
            if (uploadError) {
              uploadError.click();
            }
          }
        } else {
          if (uploadError) {
            uploadError.click();
          }
        }
      } else {
        onUpload({ data: fd });
      }
    }
  }

  // @ts-ignore
  return <Atom.File id={id} getValue={getSelectedFile} {...other} />;
}
